import React from 'react';
import {withTranslation} from "react-i18next";
import OrderPropertyComponent from "./OrderPropertyComponent";

let OrderDetailComponent = ({orderId, voucherAmount, orderedAt, voucherCodes, t, rewardClaimedDescription=null}) => {
    let date = new Date(orderedAt);
    return (<div>
        <div className="container-fluid order-details-container">
            <OrderPropertyComponent labelKey="reward.claim.details.orderDate"
                                    value={`${date.getDate()} ${t('months.' + date.getMonth())} ${date.getFullYear()}`}
                                    smWidth="12" lgWidth="4"/>
            <OrderPropertyComponent labelKey="reward.claim.details.quantity"
                                    value={`x ${voucherAmount}`}
                                    smWidth="6" lgWidth="4"/>
            <OrderPropertyComponent labelKey="reward.claim.details.reference"
                                    value={orderId}
                                    smWidth="6" lgWidth="4"/>
            {voucherCodes.map((code, index) => <OrderPropertyComponent key={`code_${code}`}
                                                                       labelKey="reward.claim.details.code"
                                                                       labelSuffix={voucherAmount===1 ? '' : ` #${index+1}`}
                                                                       value={code}
                                                                       smWidth="12" lgWidth="4"/>)}
        </div>
        {rewardClaimedDescription && <p dangerouslySetInnerHTML={{__html: rewardClaimedDescription}}/>}
    </div>);

};

export default  withTranslation() (OrderDetailComponent);